import { render, staticRenderFns } from "./Referee.vue?vue&type=template&id=3df5e4b0&scoped=true&"
import script from "./Referee.vue?vue&type=script&lang=js&"
export * from "./Referee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5e4b0",
  null
  
)

export default component.exports